import { equipments } from "../data/mock";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const IMAGE_STARRY = "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/v6akv0pg_PHOTO-2026-03-17-11-34-43.jpg";
const IMAGE_SCREEN = "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/ldzey1sp_PHOTO-2026-03-17-11-39-36.jpg";
const IMAGE_STARRY_PURPLE = "https://customer-assets.emergentagent.com/job_chauffeur-prive-29/artifacts/a0q2gl6l_PHOTO-2026-03-17-11-56-59.jpg";

export const EquipmentSection = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section ref={ref} data-testid="equipment-section" className="relative py-[80px] md:py-[100px] bg-[#1a1d2e] overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[70vw] h-[40vh] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(ellipse, rgba(201,168,76,0.07) 0%, transparent 65%)" }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div
          className={`mb-12 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p
            className="text-[12px] tracking-[0.2em] uppercase text-[#c9a84c] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            À bord
          </p>
          <h2
            className="text-[28px] md:text-[32px] font-normal text-white leading-[1.2] mb-3"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Un équipement d'exception
          </h2>
          <div className="gold-line" />
        </div>

        {/* Three images layout */}
        <div
          className={`grid grid-cols-1 md:grid-cols-3 gap-4 mb-14 transition-all duration-700 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Large image - starry purple */}
          <div className="md:col-span-2 relative overflow-hidden group">
            <img
              src={IMAGE_STARRY_PURPLE}
              alt="Intérieur Van Mercedes Classe V - Ciel étoilé LED violet et ambiance lumineuse bleue"
              className="w-full h-[280px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a1d2e]/80 to-transparent p-6">
              <span
                className="text-[14px] text-white/90"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                Ciel étoilé & ambiance LED
              </span>
            </div>
          </div>

          {/* Two stacked images */}
          <div className="flex flex-col gap-4">
            <div className="relative overflow-hidden group flex-1">
              <img
                src={IMAGE_SCREEN}
                alt="Écran multimédia - Netflix, Prime Video, Disney+, YouTube"
                className="w-full h-[130px] md:h-[192px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a1d2e]/80 to-transparent p-4">
                <span
                  className="text-[12px] text-white/80"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  Netflix, Prime Video, Disney+
                </span>
              </div>
            </div>
            <div className="relative overflow-hidden group flex-1">
              <img
                src={IMAGE_STARRY}
                alt="Tablette Spotify et ciel étoilé dans le Van Mercedes"
                className="w-full h-[130px] md:h-[192px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a1d2e]/80 to-transparent p-4">
                <span
                  className="text-[12px] text-white/80"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  Tablette & Spotify
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Equipment grid */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 delay-400 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {equipments.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 border border-white/5 hover:border-[#c9a84c]/20 transition-all duration-300"
              style={{ transitionDelay: `${400 + idx * 100}ms` }}
            >
              <div className="w-[42px] h-[42px] flex-shrink-0 flex items-center justify-center border border-[#c9a84c]/30">
                <item.icon size={20} strokeWidth={1.5} className="text-[#c9a84c]" />
              </div>
              <div>
                <h4
                  className="text-[15px] font-medium text-white mb-1"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {item.title}
                </h4>
                <p
                  className="text-[13px] text-white/45 leading-[1.5]"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
